import { Tooltip } from '@ets/design-system';

import MathML from 'Editor/modals/EquationsModal/MathML';
import { Symbol } from 'Editor/modals/EquationsModal/ToolbarElements';
import { useEquationsContext } from 'Editor/modals/EquationsModal/EquationsContext';

type CharGridItemProps = {
  element: Symbol['elements'][number];
  testId: string;
};

const CharGridItem = ({ element, testId }: CharGridItemProps) => {
  const { onElementInsertion } = useEquationsContext();

  const onClick = () => {
    onElementInsertion(element);
  };

  return (
    <div
      className="bg-neutral-5 flex cursor-pointer items-center justify-center rounded-lg shadow-[inset_0_0_0_1px_var(--colors-neutral-20)] hover:shadow-[0_4px_6px_0_rgba(0,0,0,0.2),inset_0_0_0_1px_var(--colors-neutral-20)]"
      onClick={onClick}
      data-testid={testId}
    >
      {element.mathml && element.mathml.includes('<math') ? (
        <MathML mml={element.mathml} tooltip={element.label} testId={testId} />
      ) : (
        <Tooltip content={element.label} testId={testId}>
          <div>{element.code}</div>
        </Tooltip>
      )}
    </div>
  );
};

export default CharGridItem;
